export type PaymentMethodProperties = {
    key: string // unique key (pup token or stored payment id)
    paymentSourceId: string
    displayInfo: {
        isCard: boolean
        brand: string
        lastFour: string | null
        accountExpirationDate: string | null
        lastUsedDate: string | null
    }
    paymentTodayAllowed: boolean
    data:
        | StoredPaymentMethodData
        | CardpointeCreditCard
        | CardpointeDirectDebit
        | Stripe
}

export type StoredPaymentMethodData = {
    type: 'StoredPaymentMethod'
    id: string
    isCustomerDefault: boolean
    migrationRequired: boolean
}

export type CardpointeCreditCard = {
    type: 'CardpointeCreditCard'
    token: string
}

export type CardpointeDirectDebit = {
    type: 'CardpointeDirectDebit'
    routingNumber: string
    accountNumber: string
    accountNumberConfirm: string
    accountType: 'checking' | 'savings'
}

export type Stripe = {
    type: 'Stripe'
    token: string
    amount: string
}

export type TokenPaymentMethod = {
    type: 'TokenPaymentMethod'
    token: string
    isCard: boolean
    paymentTodayAllowed: boolean
    brand: string
    lastFour: string | null
    accountExpirationDate: string | null
}

export type BankAccountPaymentMethod = {
    type: 'BankAccountPaymentMethod'
    routingNumber: string
    accountNumber: string
    accountNumberConfirm: string
    accountType: 'checking' | 'savings'
}

export const NewBankAccountKey = 'new-bank-account'
